export default {
    Active(state, val){state.access = val},
    set_asideStorage(state, val){ state.asideStorage = val; },
    setSelectedItem(state, val){ state.selectedItem = val; },
}
